import { Content } from '@prismicio/client';
import { Simplify } from '../../../../../../prismicio-types';
import { OptimizedPrismicImage } from '@/components';

import styles from './financeAccessCard.module.scss';

interface FinanceAccessCardProps {
  card: Simplify<Content.FinanceAccessSliceDefaultPrimaryCardsItem>;
}

export const FinanceAccessCard = ({ card }: FinanceAccessCardProps) => {
  if (card.card_type === 'text') {
    return (
      <div className={`${styles.card} ${styles.text_card}`}>
        <span className={styles.heading}>{card.text_card_heading}</span>
        <div className={styles.value_wrapper}>
          <span className={styles.value}>{card.text_card_value}</span>
          <div className={styles.unit_wrapper}>
            <span>+</span>
            <span>{card.text_card_unit}</span>
          </div>
        </div>
      </div>
    );
  }
  if (card.card_type === 'photo') {
    return (
      <div
        className={`${styles.card} ${styles.image_card}`}
        style={{ backgroundColor: `${card.photo_card_background}` }}
      >
        <OptimizedPrismicImage field={card.photo_card_image} />
      </div>
    );
  }

  return null;
};
